/**
 * Calculate the weight of a material in kg
 *
 * @param volume  Volume of the part in mm3
 * @param density Density of the material in g/cm³
 * @returns Weight of the material in kg
 */
export const getMaterialWeight = (
  volume: number | null | undefined,
  density: number | null | undefined,
) => {
  if (!volume || !density) {
    return 0;
  }

  return volume * 1e-6 * density;
};
